module.exports = __webpack_public_path__ + "static/img/house_windows.02967bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/param/house_windows.png
// module id = BRGa
// module chunks = 0